import api from '../../services/service'

export default {
  data () {
    return {
      role_list: [],
      role_id: 1,
      menu_list: []
    }
  },
  methods: {
    callback (val) {
      console.log(val)
    },
    getRoleData () {
      this.$store.state.isLoading = true
      api.getRole(
        result => {
          if (result.result === true) {
            this.role_list = result.data
            this.getMenu(this.role_id)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลสิทธิ์การใช้งาน',
              description: 'ดึงข้อมูลสิทธิ์การใช้งานไม่สมบูรณ์ !!'
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          console.log(error)
          this.required = true
          this.$store.state.isLoading = false
        }
      )
    },
    getMenu (roleId) {
      this.$store.state.isLoading = true
      api.getMenus(
        roleId,
        result => {
          if (result.result === true) {
            this.menu_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลเมนูการใช้งาน',
              description: 'ดึงข้อมูลเมนูการใช้งานไม่สมบูรณ์ !!'
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          console.log(error)
          this.required = true
          this.$store.state.isLoading = false
        }
      )
    },
    updatePermission (roleId, menuId) {
      this.$store.state.isLoading = true
      api.updateMenus(
        { role_id: roleId, menu_id: menuId },
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'ปรับปรุงข้อมูลเมนูการใช้งาน',
              description: 'ปรับปรุงข้อมูลเมนูการใช้งานเรียบร้อยแล้ว'
            })
            this.getMenu(roleId)
          } else {
            this.$notification['warning']({
              message: 'ปรับปรุงข้อมูลเมนูการใช้งาน',
              description: 'ปรับปรุงข้อมูลเมนูการใช้งานไม่สมบูรณ์ !!'
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          console.log(error)
          this.required = true
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.setUser()
    this.getRoleData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/permission.js